import React, { useMemo } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  SxProps,
  Theme,
} from '@mui/material';

import styles from './style';

interface CustomDialogProps {
  open: boolean;
  title?: React.ReactNode;
  children: React.ReactNode;
  // Buttons of the footer (DialogActions), none = no footer.
  actions?: React.ReactNode;
  onClose: () => void;
  maxWidth?: DialogProps['maxWidth'];
  sx?: SxProps<Theme>;
  // Overrides of the shared dark styling, for the few dialogs that differ.
  paperSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  actionsSx?: SxProps<Theme>;
}

// Dark dialog of the connected pages: the shared look is here, the content stays in the callers.
const CustomDialog: React.FC<CustomDialogProps> = React.memo((props) => {
  const {
    open,
    title,
    children,
    actions,
    onClose,
    maxWidth,
    sx,
    paperSx,
    titleSx,
    contentSx,
    actionsSx,
  } = props;

  const paperProps = useMemo(() => ({ sx: { ...styles.paper, ...paperSx } as SxProps<Theme> }), [paperSx]);

  const titleStyle = useMemo(() => ({ ...styles.title, ...titleSx } as SxProps<Theme>), [titleSx]);

  const contentStyle = useMemo(() => ({ ...styles.content, ...contentSx } as SxProps<Theme>), [contentSx]);

  const actionsStyle = useMemo(() => ({ ...styles.actions, ...actionsSx } as SxProps<Theme>), [actionsSx]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} PaperProps={paperProps} sx={sx}>
      {title && <DialogTitle sx={titleStyle}>{title}</DialogTitle>}
      <DialogContent sx={contentStyle}>
        {children}
      </DialogContent>
      {actions && <DialogActions sx={actionsStyle}>{actions}</DialogActions>}
    </Dialog>
  );
});

export default CustomDialog;
